<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// Variant info panel - variant-selects version
(function() {
  function showPanel(variantId) {
    document.querySelectorAll('.variant-info-css-item').forEach(function(el) {
      el.style.display = el.dataset.variant === String(variantId) ? 'block' : 'none';
    });
  }

  function getSelectedVariantId() {
    // 方法1：从隐藏的 input[name="id"] 获取
    var idInput = document.querySelector('input[name="id"]');
    if (idInput && idInput.value) return idInput.value;

    // 方法2：从 variant-selects 内的 JSON 数据匹配当前选中的 select 值
    var variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return null;

    var variantsJson = variantSelects.querySelector('script[type="application/json"]');
    if (!variantsJson) return null;

    var variants = JSON.parse(variantsJson.textContent);
    var selects = variantSelects.querySelectorAll('select');
    var selectedOptions = Array.from(selects).map(function(s) {
      return s.value;
    });

    var matched = variants.find(function(v) {
      return v.options.every(function(opt, i) {
        return opt === selectedOptions[i];
      });
    });

    return matched ? matched.id : null;
  }

  function init() {
    // 初始化显示
    var variantId = getSelectedVariantId();
    if (variantId) showPanel(variantId);

    // 监听 select 变化
    document.addEventListener('change', function(e) {
      if (e.target.tagName === 'SELECT' && e.target.closest('variant-selects')) {
        setTimeout(function() {
          var vid = getSelectedVariantId();
          if (vid) showPanel(vid);
        }, 100);
      }
    });

    // 监听方形按钮点击（label 点击）
    document.addEventListener('click', function(e) {
      var label = e.target.closest('label');
      if (!label) return;
      if (!label.closest('variant-radios') && !label.closest('.halo-productOptions')) return;
      setTimeout(function() {
        var vid = getSelectedVariantId();
        if (vid) showPanel(vid);
      }, 150);
    });

    // 用主题 subscribe 监听
    if (typeof subscribe === 'function') {
      subscribe('variant-change', function(data) {
        if (data && data.variant && data.variant.id) {
          showPanel(data.variant.id);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 600);
    });
  } else {
    setTimeout(init, 600);
  }
})();

// Sync aria-expanded with language dropdown visibility
(function () {
  var btn = document.querySelector('.disclosure__button[aria-controls="HeaderLanguageList"]');
  var dropdown = document.querySelector('.dropdown-language');
  if (!btn || !dropdown) return;

  var observer = new MutationObserver(function () {
    var isVisible = getComputedStyle(dropdown).display !== 'none'
      && getComputedStyle(dropdown).visibility !== 'hidden'
      && getComputedStyle(dropdown).opacity !== '0';
    btn.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
  });

  observer.observe(dropdown, { attributes: true, attributeFilter: ['style', 'class'] });

  btn.addEventListener('click', function () {
    setTimeout(function () {
      var isVisible = getComputedStyle(dropdown).display !== 'none'
        && getComputedStyle(dropdown).visibility !== 'hidden'
        && getComputedStyle(dropdown).opacity !== '0';
      btn.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
    }, 50);
  });
})();

// Fix aria-expanded and aria-label on glc switcher button
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var glcBtn = document.querySelector('.glc-switcher-btn');
    if (!glcBtn) return;

    // Force aria-label and watch for app overrides
    glcBtn.setAttribute('aria-label', 'Change region, language and currency');
    var labelObserver = new MutationObserver(function () {
      if (glcBtn.getAttribute('aria-label') !== 'Change region, language and currency') {
        glcBtn.setAttribute('aria-label', 'Change region, language and currency');
      }
    });
    labelObserver.observe(glcBtn, { attributes: true, attributeFilter: ['aria-label'] });

    // Sync aria-expanded with dropdown visibility
    var dropdown = document.getElementById('switcher-selector');
    if (dropdown) {
      var expandedObserver = new MutationObserver(function () {
        var isExpanded = getComputedStyle(dropdown).display !== 'none'
          && getComputedStyle(dropdown).visibility !== 'hidden';
        glcBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
      expandedObserver.observe(dropdown, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    glcBtn.addEventListener('click', function () {
      setTimeout(function () {
        var dropdown = document.getElementById('switcher-selector');
        if (!dropdown) return;
        var isExpanded = getComputedStyle(dropdown).display !== 'none'
          && getComputedStyle(dropdown).visibility !== 'hidden';
        glcBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }, 80);
    });
  }, 1000);
});

// Fix hidden search label accessibility
(function () {
  function fixSearchLabel() {
    var searchLabel = document.querySelector('label[for="Search-In-Modal-Menu-Plain"]');
    if (searchLabel && searchLabel.classList.contains('hiddenLabels')) {
      searchLabel.classList.remove('hiddenLabels');
      searchLabel.classList.add('visually-hidden');
    }
  }

  var observer = new MutationObserver(function () {
    fixSearchLabel();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', fixSearchLabel);
})();


// Batch accessibility fixes for all modals and sidebars
(function () {
  var dialogs = [
    {
      selector: '.search-modal.modal__content',
      label: 'Search',
      focusTarget: '#Search-In-Modal-Menu-Plain'
    },
    {
      selector: 'newsletter-popup.halo-newsletter-popup',
      label: 'Newsletter signup'
    },
    {
      selector: '.newsletter-success-modal',
      label: 'Newsletter success',
      focusTarget: '.halo-modal-body'
    },
    {
      selector: '.halo-lookbook-popup',
      label: 'Lookbook'
    },
    {
      selector: '.halo-video-popup',
      label: 'Video'
    },
    {
      selector: '.halo-quick-view-popup',
      label: 'Quick view'
    },
    {
      selector: '.halo-edit-cart-popup',
      label: 'Edit cart'
    },
    {
      selector: '.halo-warning-popup',
      label: 'Warning'
    },
    {
      selector: '.halo-cart-sidebar',
      label: 'Shopping cart'
    },
    {
      selector: 'customer-auth.halo-auth-sidebar',
      label: 'Account'
    },
    {
      selector: '.search-form-mobile.halo-sidebar',
      label: 'Search'
    },
    {
      selector: '.navigation-mobile.halo-sidebar',
      label: 'Navigation menu'
    }
  ];

  function applyDialogAttrs(el, label) {
    if (!el.getAttribute('role')) {
      el.setAttribute('role', 'dialog');
    }
    el.setAttribute('aria-modal', 'true');
    if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
      el.setAttribute('aria-label', label);
    }
    if (!el.hasAttribute('tabindex')) {
      el.setAttribute('tabindex', '-1');
    }
  }

  function applyInert(dialogEl) {
    var main = document.querySelector('#main-content, main, [role="main"]');
    if (main && main !== dialogEl && !main.contains(dialogEl)) {
      main.setAttribute('inert', '');
      main.setAttribute('aria-hidden', 'true');
    }
  }

  function removeInert() {
    var main = document.querySelector('#main-content, main, [role="main"]');
    if (main) {
      main.removeAttribute('inert');
      main.removeAttribute('aria-hidden');
    }
  }

function focusDialog(el, focusTarget) {
  setTimeout(function () {
    var target = null;
    if (focusTarget) {
      target = el.querySelector(focusTarget) || document.querySelector(focusTarget);
    }
    if (!target) target = el;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus();
  }, 150);
}

  function setupDialog(config) {
    var el = document.querySelector(config.selector);
    if (!el) return;

    applyDialogAttrs(el, config.label);

    // Watch for visibility changes to manage inert and focus
    var observer = new MutationObserver(function () {
      var isVisible = getComputedStyle(el).display !== 'none'
        && getComputedStyle(el).visibility !== 'hidden'
        && !el.hasAttribute('hidden');

      if (isVisible) {
        applyInert(el);
        focusDialog(el, config.focusTarget);
      } else {
        removeInert();
      }
    });

    observer.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  function init() {
    dialogs.forEach(function (config) {
      setupDialog(config);
    });
  }

  // Wait for dynamic elements
  var bodyObserver = new MutationObserver(function () {
    dialogs.forEach(function (config) {
      var el = document.querySelector(config.selector);
      if (el && !el.hasAttribute('aria-modal')) {
        setupDialog(config);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    init();
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  });
})();

// Fix halo-sidebar-close anchor keyboard accessibility
(function () {
  function fixSidebarCloseLinks() {
    document.querySelectorAll('a.halo-sidebar-close').forEach(function (el) {
      if (el._keydownFixed) return; // prevent duplicate listeners
      el._keydownFixed = true;
      if (!el.getAttribute('role')) el.setAttribute('role', 'button');
      if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Close');
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          el.click();
        }
      });
    });
  }

  function fixCloseButtons() {
    // halo-sidebar-close tabindex is managed here only (not in fixSidebarCloseLinks)
    document.querySelectorAll('.halo-popup-close, .close.close-modal, a.halo-sidebar-close').forEach(function (el) {
      var popup = el.closest('[class*="popup"], [class*="sidebar"], [class*="modal"]');
      var isVisible = popup
        ? getComputedStyle(popup).display !== 'none' && getComputedStyle(popup).visibility !== 'hidden'
        : getComputedStyle(el).display !== 'none';
      el.setAttribute('tabindex', isVisible ? '0' : '-1');
    });
  }

  function fixSlides() {
    document.querySelectorAll('.slide-image, a.image').forEach(function (el) {
      var slide = el.closest('.slick-slide, [class*="slide"]');
      var isActive = slide
        ? slide.classList.contains('slick-active') || slide.classList.contains('is-selected')
        : true;
      el.setAttribute('tabindex', isActive ? '0' : '-1');
      if (!isActive) el.setAttribute('aria-hidden', 'true');
      else el.removeAttribute('aria-hidden');
    });
  }

  function runAll() {
    fixSidebarCloseLinks();
    fixCloseButtons();
    fixSlides();
  }

  document.addEventListener('DOMContentLoaded', function () {
    runAll();
    // Single unified observer for all dynamic fixes
    var observer = new MutationObserver(runAll);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  });
})();


// Fix account link: focus new content container after click
(function () {
  function focusAuthContainer() {
    var targets = [
      'customer-auth.halo-auth-sidebar',
      '.halo-auth-sidebar',
      '#customer_login',
      '#login-form',
      '.customer-login',
      '[id*="auth"]'
    ];
    for (var i = 0; i < targets.length; i++) {
      var el = document.querySelector(targets[i]);
      if (el && getComputedStyle(el).display !== 'none') {
        if (!el.hasAttribute('tabindex')) {
          el.setAttribute('tabindex', '-1');
        }
        el.focus();
        return true;
      }
    }
    return false;
  }

  function setupAccountLink() {
    var accountLink = document.querySelector('a.header__icon--account, a[href="/account/login"], a[href*="/account"]');
    if (!accountLink || accountLink._authFixed) return;
    accountLink._authFixed = true;

    accountLink.addEventListener('click', function () {
      // Try immediately, then retry for dynamically injected content
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (focusAuthContainer() || attempts >= 10) {
          clearInterval(interval);
        }
      }, 100);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupAccountLink();
    // Watch for dynamic injection
    var observer = new MutationObserver(setupAccountLink);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();


// Fix newsletter message popup: focus message container when it appears
(function () {
  function setupNewsletterMessagePopup() {
    // Target both possible containers
    var popups = [
      { selector: '.halo-newsletter-message-popup', msgSelector: '.newsletter-message' },
      { selector: '.newsletter-success-modal', msgSelector: '.newsletter-success-modal' }
    ];

    popups.forEach(function(config) {
      var popup = document.querySelector(config.selector);
      if (!popup || popup._newsletterMsgFixed) return;
      popup._newsletterMsgFixed = true;

      var messageEl = document.querySelector(config.msgSelector) || popup;
      if (!messageEl.hasAttribute('tabindex')) {
        messageEl.setAttribute('tabindex', '-1');
      }

      var observer = new MutationObserver(function () {
        var isVisible = getComputedStyle(popup).display !== 'none'
          && getComputedStyle(popup).visibility !== 'hidden'
          && !popup.hasAttribute('hidden');

        if (isVisible) {
          setTimeout(function () {
            messageEl.focus();
          }, 100);
        }
      });

      observer.observe(popup, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupNewsletterMessagePopup();
    var observer = new MutationObserver(setupNewsletterMessagePopup);
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
